import React from 'react'
import { TaskPropsType } from './types'
import NotionRenderer from '@famiryru/react-notion-renderer'

// Styles
import './styles.scss'

// Images
import IconBookmark from './images/iconBookmark'
import IconTask from './images/iconTask'

export default ({ title, style, notionBlocks, showIcon }: TaskPropsType) => {
  return (
    <div
      className={'task'}
      style={showIcon ? style : { ...style, padding: '60px 28px 25px 45px' }}
    >
      <div
        className={'task__bookmark'}
        style={showIcon ? {} : { right: '6.5%', top: -20, left: 'unset' }}
      >
        <IconBookmark />
      </div>
      {showIcon ? (
        <div className={'task__left'}>
          <IconTask />
        </div>
      ) : null}
      <div className={'task__block'} style={showIcon ? {} : { marginLeft: 0 }}>
        <span className={'task__block-title'}>
          {title ? title : 'Описание урока'}
        </span>
        <NotionRenderer blocks={notionBlocks} />
      </div>
    </div>
  )
}
